<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #homefilterdesk>
    <div class="figma4">
        <app-city [mode]="'home'"></app-city>
        @if(start() && end()) {
        <clever-date [start]="start()" [end]="end()" [customwidth]="'425px'" (selectValue)="selectValue($event)" [mode]="'home'"
            class="w300px"></clever-date>
        }
        <!-- <clever-dauer [mode]="'home'" [class.disableddauer]="type === 'oneway'"></clever-dauer> -->
        <clever-selectionlist [icon]="'people_alt'"
            [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
            (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [list]="reisende" [mode]="'home'">
        </clever-selectionlist>
        <!-- <button matTooltip="Mehr Filter" (click)="openclosemore()" matRipple>
             <mat-icon fontIcon="more_vert"></mat-icon>
         </button> -->
        <button (click)="gotoZiel()" class="custombutton">
            <img src="../../../../assets/tvg/search.svg" alt="search" />
            <span>{{btntext()}}</span>
        </button>
    </div>
    <!-- <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <app-city [mode]="'home'"></app-city>
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            <clever-selectionlist [icon]="'people_alt'"
                [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
                (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [toprightradius]="true"
                [bottomrightradius]="true" [list]="reisende" [mode]="'home'">
            </clever-selectionlist>

            <button matTooltip="Mehr Filter" (click)="openclosemore()" matRipple>
                <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext}}</span>
            </button>
        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div> -->
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">


        <div class="figma4_mobile">
            <app-city [mode]="'home'"></app-city>
            @if(start() && end()) {
            <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            }
            <!-- <clever-dauer [mode]="'home'" [class.disableddauer]="type === 'oneway'"></clever-dauer> -->
            <clever-selectionlist [icon]="'people_alt'"
                [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
                (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [list]="reisende" [mode]="'home'">
            </clever-selectionlist>
            <!-- <button matTooltip="Mehr Filter" (click)="openclosemore()" matRipple>
             <mat-icon fontIcon="more_vert"></mat-icon>
         </button> -->
            <button (click)="gotoZiel()" class="custombutton">
                <img src="../../../../assets/tvg/search.svg" alt="search" />
                <span>{{btntext()}}</span>
            </button>
        </div>
    </div>
    <!-- <div class="tmp-inputs-wrapper-mobile">
        <div class="tmp-extrafilter-wraper-mobile w100">
            <app-city [mode]="'home'" class="w100"></app-city>
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w100"></clever-date>
            <clever-selectionlist class="w100" [icon]="'people_alt'"
                [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
                (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [bottomleftradius]="true"
                [bottomrightradius]="true" [list]="reisende" [mode]="'home'">
            </clever-selectionlist>
            <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilterMobile"></ng-container>
            <button matTooltip="Mehr Filter" class="tmp-mehrfilter-mobile" (click)="openclosemore()" matRipple>
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span>{{btntext}}</span>
            </button>
        </div>
    </div> -->
</ng-template>

<ng-template #nohomefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="nohomemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="nohomefilterdesk"></ng-container>
    }
    }
</ng-template>


<ng-template #nohomemodeMobile>
    <ng-container *ngIf="smallVersion else mbfilter">
        <div class="tmp-inputs-wrapper-nohome-mobile">
            <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
                <div class="m05">
                    <app-city [mode]="'nohomesmall'" class="w100"></app-city>
                    <div class="smallfilter-body">
                        <span class="smallitem">
                            @if (start()?.length > 0 && end()?.length > 0) {
                                <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)"
                                    [mode]="'nohomesmall'"></clever-date> |
                            }
                        </span>
                        <span class="smallitem">
                            {{filter?.adults}} P
                        </span>
                    </div>
                </div>
                <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                    <mat-icon fontIcon="search"></mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #mbfilter>
    <div class="smallfilterbig-mobile-wrapper">
        <app-city [mode]="'nohome'" class="w100"></app-city>
        <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'nohome'"
            class="w100"></clever-date>
        <clever-selectionlist class="w100" [icon]="'people_alt'"
            [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
            (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [list]="reisende" [mode]="'nohome'">
        </clever-selectionlist>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <app-city [mode]="'nohome'" class="w100"></app-city>
        @if(start() && end()) {
        <clever-date [start]="start()" [end]="end()" (selectValue)="selectValue($event)" [mode]="'nohome'"
            class="w100"></clever-date>
        }
        <clever-selectionlist class="w100" [icon]="'people_alt'"
            [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
            (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [list]="reisende" [mode]="'nohome'">
        </clever-selectionlist>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span>{{btntext()}}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilterMobile>
    <app-carrentextrafilters [mode]="'home'" class="w100" (closeModal)="openclosemore()">
    </app-carrentextrafilters>
</ng-template>

<ng-template #moreFilter>
    <app-carrentextrafilters [mode]="'home'" class="w100" (closeModal)="openclosemore()">
    </app-carrentextrafilters>
</ng-template>